module.exports = __webpack_public_path__ + "img/firma-pt.e0c7b5da.png";